import api from '../../../lib/api'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'

export const AUDIT_LABEL_FETCHING = 'AUDIT_LABEL_FETCHING'
export const AUDIT_LABEL_DONE = 'AUDIT_LABEL_DONE'
export const AUDIT_LABEL_FAILED = 'AUDIT_LABEL_FAILED'

export const PRODUCT_FAILURE_DETAILS_FETCHING =
  'PRODUCT_FAILURE_DETAILS_FETCHING'
export const PRODUCT_FAILURE_DETAILS_DONE = 'PRODUCT_FAILURE_DETAILS_DONE'
export const PRODUCT_FAILURE_DETAILS_FAILED = 'PRODUCT_FAILURE_DETAILS_FAILED'

export const AUDIT_RULES_FETCHING = 'AUDIT_RULES_FETCHING'
export const AUDIT_RULES_DONE = 'AUDIT_RULES_DONE'
export const AUDIT_RULES_FAILED = 'AUDIT_RULES_FAILED'

export const FEED_WITH_FAILURES_PROGRESS_FETCHING =
  'FEED_WITH_FAILURES_PROGRESS_FETCHING'
export const FEED_WITH_FAILURES_PROGRESS_DONE =
  'FEED_WITH_FAILURES_PROGRESS_DONE'
export const FEED_WITH_FAILURES_PROGRESS_FAILED =
  'FEED_WITH_FAILURES_PROGRESS_FAILED'

export const GENERATE_FEED_WITH_FAILURES_FETCHING =
  'GENERATE_FEED_WITH_FAILURES_FETCHING'
export const GENERATE_FEED_WITH_FAILURES_DONE =
  'GENERATE_FEED_WITH_FAILURES_DONE'
export const GENERATE_FEED_WITH_FAILURES_FAILED =
  'GENERATE_FEED_WITH_FAILURES_FAILED'

const fetchingAuditLabelData = () => ({
  type: AUDIT_LABEL_FETCHING,
})
export const receivedAuditLabelData = auditLabel => ({
  type: AUDIT_LABEL_DONE,
  auditLabel,
})
const failedAuditLabelData = message => ({
  type: AUDIT_LABEL_FAILED,
  message,
})

const fetchingProductFailureDetails = () => ({
  type: PRODUCT_FAILURE_DETAILS_FETCHING,
})
const receivedProductFailureDetails = (
  productFailureDetails,
  pageTotal,
  page
) => ({
  type: PRODUCT_FAILURE_DETAILS_DONE,
  productFailureDetails,
  pageTotal,
  page,
})
const failedProductFailureDetails = message => ({
  type: PRODUCT_FAILURE_DETAILS_FAILED,
  message,
})

const fetchingAuditRulesData = () => ({
  type: AUDIT_RULES_FETCHING,
})
export const receivedAuditRulesData = auditRules => ({
  type: AUDIT_RULES_DONE,
  auditRules,
})
const failedAuditRulesData = message => ({
  type: AUDIT_RULES_FAILED,
  message,
})

const fetchingFeedWithFailuresProgress = () => ({
  type: FEED_WITH_FAILURES_PROGRESS_FETCHING,
})
const receivedFeedWithFailuresProgress = progress => ({
  type: FEED_WITH_FAILURES_PROGRESS_DONE,
  progress,
})
const failedFeedWithFailuresProgress = message => ({
  type: FEED_WITH_FAILURES_PROGRESS_FAILED,
  message,
})

const fetchingGenerateFeedWithFailures = () => ({
  type: GENERATE_FEED_WITH_FAILURES_FETCHING,
})
const receivedGenerateFeedWithFailures = () => ({
  type: GENERATE_FEED_WITH_FAILURES_DONE,
})
const failedGenerateFeedWithFailures = message => ({
  type: GENERATE_FEED_WITH_FAILURES_FAILED,
  message,
})

export function getAuditLabelById(auditId, dispatch) {
  dispatch(fetchingAuditLabelData())

  api
    .get(`/feedaudit/label/${auditId}`)
    .then(({ data }) => {
      dispatch(receivedAuditLabelData(data.label))
    })
    .catch(error => {
      console.log(error.message)
      dispatch(failedAuditLabelData(error.message))
      return error
    })
}

export function getProductFailureDetailsById(
  auditId,
  dispatch,
  page = 0,
  limit = 10,
  ruleFilter = '00000000-0000-0000-0000-000000000000'
) {
  dispatch(fetchingProductFailureDetails())

  let filters = new URLSearchParams({
    page: page + 1,
    limit: limit,
    ruleId: ruleFilter,
  })

  api
    .get(`/feedaudit/product-failure/${auditId}?${filters}`)
    .then(({ data, headers: { fm_pagination_total } }) => {
      const pageTotal = Math.ceil(fm_pagination_total / limit)
      dispatch(receivedProductFailureDetails(data, pageTotal, page))
    })
    .catch(error => {
      console.log(error.message)
      dispatch(failedProductFailureDetails(error.message))
      return error
    })
}

export function getAuditRulesById(dispatch) {
  dispatch(fetchingAuditRulesData())

  api
    .get(`/feedaudit/rules/detailed`)
    .then(({ data }) => {
      dispatch(receivedAuditRulesData(data))
    })
    .catch(error => {
      console.log(error.message)
      dispatch(failedAuditRulesData(error.message))
      return error
    })
}

export function generateFeedWithFailures(t, auditId, dispatch) {
  dispatch(fetchingGenerateFeedWithFailures())

  api
    .post(`/feedaudit/product-failure/${auditId}/feed`)
    .then(() => {
      toast.warn(t('wait_for_file'), { autoClose: 5000 })
      dispatch(receivedGenerateFeedWithFailures())
      dispatch(receivedFeedWithFailuresProgress(1)) // File generation is in progress
    })
    .catch(error => {
      console.log(error.message)
      dispatch(failedGenerateFeedWithFailures(error.message))
      return error
    })
}

export function getFeedWithFailuresProgress(auditId, dispatch) {
  dispatch(fetchingFeedWithFailuresProgress())

  api
    .get(`/feedaudit/product-failure/${auditId}/feed/progress`)
    .then(({ data }) => {
      dispatch(receivedFeedWithFailuresProgress(data.progress))
    })
    .catch(error => {
      console.log(error.message)
      dispatch(failedFeedWithFailuresProgress(error.message))
      return error
    })
}

export function downloadFeedWithFailuresFile(t, auditId, auditLabel) {
  toast.info(t('download_request'))

  return api
    .get(`/feedaudit/product-failure/${auditId}/feed/download`, {
      responseType: 'blob',
      timeout: 0,
    })
    .then(({ data, headers, status }) => {
      // File is still being generated
      if (status === 202) {
        toast.warn(t('wait_for_file'), { autoClose: 5000 })
        return
      }

      let fileName = auditLabel + '-feed-with-failures.csv'
      toast.success(t('downloading_file'))
      saveAs(
        new Blob([data], {
          type: headers['content-type'],
        }),
        fileName
      )
    })
    .catch(() => toast.error(t('download_request_error')))
}
